import { defineComponent, ref, watch, createElementBlock, openBlock, createElementVNode, createCommentVNode } from "vue";
const _hoisted_1 = { class: "receipt-default" };
const _hoisted_2 = { class: "receipt-wrapper" };
const _hoisted_3 = ["innerHTML"];
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "ReceiptDefault",
  props: {
    order: {
      type: Object,
      required: true
    },
    options: {
      type: Object,
      default: () => {
      }
    },
    venue: {
      type: Object,
      default: () => void 0
    },
    isRetail: {
      type: Boolean,
      default: false
    }
  },
  setup(__props) {
    const props = __props;
    const html = ref("");
    watch(() => JSON.stringify(props.options), (val, oldVal) => {
      setHtml();
    }, { immediate: true });
    async function setHtml() {
      const printable = await props.order.getPrintable(props.options, props.venue);
      html.value = (await printable.toHtml({ useComponent: false })).forPrint();
    }
    setHtml();
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1, [
        createElementVNode("div", _hoisted_2, [
          html.value ? (openBlock(), createElementBlock("div", {
            key: 0,
            innerHTML: html.value,
            class: "printable-area"
          }, null, 8, _hoisted_3)) : createCommentVNode("", true)
        ])
      ]);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=index9.js.map
